var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLumino(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 60,
    viewBox: "0 0 54 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 29.1351L2.78987 24.001L25.5126 39.8357V57.4203L24.9499 56.8576L9.75683 40.5391L1 29.1351Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5743 39.4137L27.9745 57.4203V50.2458L50.5531 24.001L52.5225 29.1351L44.5743 39.4137Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.11292 22.5467L9.07551 0L18.1696 18.1463H25.5874V33.2753V50.9606L9.07551 33.2753L1.11292 22.5467Z",
    fill: "#FECA28"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5345 22.5467L44.5719 0L35.4778 18.1463H28.06V33.2753V50.9606L44.5719 33.2753L52.5345 22.5467Z",
    fill: "#FECA28"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03584 39.6874L1.07324 28.9588L9.03584 6.41211L18.13 24.5585H25.5478V39.6874M9.03584 39.6874H25.5478M9.03584 39.6874L25.5478 57.3727V39.6874M44.5323 39.6874L52.4949 28.9588L44.5323 6.41211L35.4381 24.5585H28.0203V39.6874M44.5323 39.6874H28.0203M44.5323 39.6874L28.0203 57.3727V39.6874",
    stroke: "black",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLumino);
export default __webpack_public_path__ + "static/media/logoLumino.ede8ffbe.svg";
export { ForwardRef as ReactComponent };